import { render, staticRenderFns } from "./v-upload-knowledge.vue?vue&type=template&id=8d33877c&"
import script from "./v-upload-knowledge.vue?vue&type=script&lang=js&"
export * from "./v-upload-knowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports